import { useState } from 'react'
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom'
import { LINKS, isMobileClient } from '../config/links'
import { TOPICS } from '../seo/topics'
import { GetAppModal } from './GetAppModal'
import './SiteChrome.css'

export function SiteChrome() {
  const [qrOpen, setQrOpen] = useState(false)
  const navigate = useNavigate()

  const openGetApp = () => {
    if (isMobileClient()) {
      navigate('/download-app')
      return
    }
    setQrOpen(true)
  }

  return (
    <div className="site">
      <div className="site__atmosphere" aria-hidden>
        <span className="site__orb site__orb--a" />
        <span className="site__orb site__orb--b" />
      </div>

      <header className="site__nav">
        <div className="shell site__nav-inner">
          <Link to="/" className="site__logo" aria-label="Music24 home">
            <img src="/logo.png" alt="Music24" className="site__logo-img" />
          </Link>

          <nav className="site__links" aria-label="Primary">
            <NavLink to="/stations">Stations</NavLink>
            <NavLink to="/download">Download</NavLink>
            <a href={LINKS.webApp} target="_blank" rel="noopener noreferrer">
              Web app
            </a>
          </nav>

          <button type="button" className="site__cta" onClick={openGetApp}>
            Get the app
          </button>
        </div>
      </header>

      <Outlet context={{ openGetApp }} />

      <footer className="site__footer">
        <div className="shell site__footer-inner">
          <div className="site__footer-col site__footer-col--brand">
            <Link to="/" className="site__footer-brand" aria-label="Music24 home">
              <img src="/logo.png" alt="Music24" className="site__footer-logo-img" />
            </Link>
            <p className="site__footer-tagline">Free Jewish music radio, anytime.</p>
          </div>

          <nav className="site__footer-col site__footer-col--nav" aria-label="Footer navigation">
            <p className="site__footer-label">Explore</p>
            <Link to="/stations">Stations</Link>
            <Link to="/download">Download</Link>
            <a href={LINKS.webApp} target="_blank" rel="noopener noreferrer">Web app</a>
          </nav>

          <nav className="site__footer-col site__footer-col--guides" aria-label="Jewish music guides">
            <p className="site__footer-label">Listen</p>
            {TOPICS.map((topic) => (
              <Link key={topic.path} to={topic.path}>{topic.nav}</Link>
            ))}
          </nav>

          <div className="site__footer-col site__footer-col--legal">
            <p className="site__footer-label">Company</p>
            <Link to="/contact">Contact</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </div>
        </div>

        <div className="shell site__footer-bottom">
          <p className="site__footer-copy">© {new Date().getFullYear()} Music24. All rights reserved.</p>
        </div>
      </footer>

      <GetAppModal open={qrOpen} onClose={() => setQrOpen(false)} />
    </div>
  )
}
